var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 4.80078H8.00403M7.9987 10.1341V6.80078M14.6654 7.46745C14.6654 11.1494 11.6807 14.1341 7.9987 14.1341C4.3167 14.1341 1.33203 11.1494 1.33203 7.46745C1.33203 3.78545 4.3167 0.800781 7.9987 0.800781C11.6807 0.800781 14.6654 3.78545 14.6654 7.46745Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceInfo);
export default __webpack_public_path__ + "static/media/price-info.92a302a236f4830928473e9ffc6baaf7.svg";
export { ForwardRef as ReactComponent };